import _ from 'lodash';
import { createSelector } from 'reselect';

import {
  selectFinancialInfoAllTablesData,
  selectFinancialInfoBorrowers,
} from './financialInfo.selectors';
import { selectBorrowersTableData } from './loanApplicationBorrowers.selectors';
import { selectNonBorrowersTableData } from './loanApplicationNonBorrowers.selectors';

const getFinancialRecordDisplayName = record =>
  record.creditorName ?? record.employerName ?? record.institution ?? record.address ?? null;

// Maps a presence location's entityId (a borrower, non-borrower, or financial-info record) to
// a display name for the loan-editor presence UI (PresenceEntityDot / usePresenceLocationUpdate).
export const selectEntityNameMap = createSelector(
  selectBorrowersTableData,
  selectNonBorrowersTableData,
  selectFinancialInfoAllTablesData,
  selectFinancialInfoBorrowers,
  (borrowers, nonBorrowers, financialData, financialInfoBorrowers) => {
    const nameMap = {};

    (borrowers ?? []).forEach(({ id, fullName }) => {
      nameMap[id] = fullName;
    });

    (nonBorrowers ?? []).forEach(({ id, fullName }) => {
      nameMap[id] = fullName;
    });

    (financialInfoBorrowers ?? []).forEach(({ id, fullName }) => {
      if (!_.isNil(fullName)) {
        nameMap[id] = fullName;
      }
    });

    Object.values(financialData).forEach(records =>
      records.forEach(record => {
        const displayName = getFinancialRecordDisplayName(record);

        if (!_.isNil(displayName)) {
          nameMap[record.id] = displayName;
        }
      }),
    );

    return nameMap;
  },
);
